export default class ValidationService {
    static doesStringHaveInvalidCharacters(str) {
        return ValidationService.validInputPattern().test(str);
    }
    static isString(x) {
        return Object.prototype.toString.call(x) === "[object String]";
    }

    static isStringNullOrEmpty(str) {
        return !str.trim() || str.length === 0;
    }

    static validInputPattern() {
        return /[^0-9a-zA-Z\f\n\r\t\v\$\(\)\*\+\.\?\\\^\{\}\[\]\u0022 !#%&'-/@_`:~\u2019\u2013]/;
    }

    static validSortCode(sortCode) {
        return sortCode === "OF" ||
            sortCode === "OR" ||
            sortCode === "MP" ||
            sortCode === "BM" ||
            sortCode === "BV" ||
            sortCode === "BA" ||
            sortCode === "BD" ||
            sortCode === "IA" ||
            sortCode === "ID" ||
            sortCode === "GI" ||
            sortCode === "PA" ||
            sortCode === "PD" ||
            sortCode === "RI" ||
            sortCode === "MO" ||
            sortCode === "C1" ||
            sortCode === "C2";
    }

    static validateByPattern(pattern, key) {
        let regex = new RegExp(pattern);
        return regex.test(key);
    }

    static digitsOnly(key) {
        let regex = /[^0-9]/;
        return regex.test(key);
    }

    static validateMoneyValue(key) {
        let regex = /[^0-9.]/;
        let decimalCountLessThanTwo = (key.split('.').length - 1) < 2;
        let hasDecimal = key.indexOf('.') === -1;
        let charsAfterDecimalLessThanThree = (key.length - key.indexOf('.') - 1) < 3;
        return !regex.test(key) && decimalCountLessThanTwo && (charsAfterDecimalLessThanThree || hasDecimal);
    }
};